<template lang="pug">
Page.advantages-edit
    .advantages-edit__top(
        slot="header"
    )
        h1.advantages-edit__title
            | Создание преимуществ компании

        SvMenu(
            @copy="copy"
            @remove="remove"
        )

    SvTabs.advantages-edit__table(
        :tabs="['Основное']"
        :current="0"
    )
        .advantages-edit__actions
            SvButton.advantages-edit__action(
                view="secondary"
                text="Отмена"
                :prependIcon=`{
                    icon: 'cancel',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="resetForm"
            )

            SvButton.advantages-edit__action(
                view="secondary"
                text="Применить"
                :prependIcon=`{
                    icon: 'refresh',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="save(false)"
            )

            SvButton.advantages-edit__action(
                view="primary"
                text="Сохранить"
                :prependIcon=`{
                    icon: 'check',
                    width: 24,
                    height: 24,
                    default: '#1993EB',
                    hover: '#1993EB'
                }`
                @click="save(true)"
            )

    .advantages-edit__form
        .advantages-edit__form-item
            span.advantages-edit__form-title
                | Активность

            .advantages-edit__form-elements--small.radio
                SvRadio.advantages-edit__form-radio(
                    v-model="is_active"
                    :value="true"
                    label="Да"
                )

                SvRadio.advantages-edit__form-radio(
                    v-model="is_active"
                    :value="false"
                    label="Нет"
                )

        .advantages-edit__form-item
            span.advantages-edit__form-title
                | Сортировка

            .advantages-edit__form-elements--small
                SvInput(
                    v-model="sort"
                    color="graylight"
                    placeholder="Например: 500"
                    :withIcon="false"
                )

        .advantages-edit__form-item
            span.advantages-edit__form-title
                | Краткое название

            .advantages-edit__form-elements--small
                SvInput(
                    v-model="name"
                    placeholder="Например: jiloy-complex"
                    color="graylight"
                    :withIcon="false"
                )

        .advantages-edit__form-item
            span.advantages-edit__form-title
                | Символьный код

            .advantages-edit__form-elements--small
                SvInput(
                    v-model="alias"
                    placeholder="Например: jiloy-complex"
                    color="graylight"
                    :withIcon="false"
                )

        .advantages-edit__form-item
            span.advantages-edit__form-title
                | Заголовок

            .advantages-edit__form-elements--medium
                SvInput(
                    v-model="title"
                    placeholder="Например: jiloy-complex"
                    color="graylight"
                    :withIcon="false"
                )

        .advantages-edit__form-item
            span.advantages-edit__form-title
                | Описание

            .advantages-edit__form-elements--medium
                SvInput(
                    v-model="description"
                    placeholder="Например: jiloy-complex"
                    color="graylight"
                    :withIcon="false"
                )

        .advantages-edit__form-item
            span.advantages-edit__form-title
                | Изображение

            .advantages-edit__form-elements--small
                SvUpload(
                    v-model="icon"
                )
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvMenu from '@/components/uikit/SvMenu.vue';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTabs from '@/components/uikit/SvTabs.vue';
import SvUpload from '@/components/uikit/SvUpload.vue';
import { rusToLatin } from '@/helpers/transform';

export default {
  name: 'AdvantagesCompanyEdit',


  beforeMount() {
    this.$store.dispatch('advantageCompany/getById', this.$route.params.id);
  },

  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== 'new') {
      this.$store.dispatch('advantageCompany/getById', to.params.id);
    }
    next();
  },

  computed: {
    ...mapGetters({
      current: 'advantageCompany/getCurrent',
    }),

    is_active: {
      get() {
        // Обертка Boolean, т.к. с севера приходит 1 или 0
        return Boolean(this.current.is_active);
      },
      set(is_active) {
        this.setValue({ is_active });
      },
    },

    sort: {
      get() {
        return this.current.sort;
      },

      set(sort) {
        this.setValue({ sort });
      },
    },

    title: {
      get() {
        return this.current.title;
      },
      set(title) {
        this.setValue({ title });
      },
    },

    alias: {
      get() {
        return this.current.alias;
      },

      set(alias) {
        this.setValue({ alias });
      },
    },

    name: {
      get() {
        return this.current.name;
      },

      set(name) {
        this.setValue({ name });
        this.setValue({ alias: rusToLatin(title) });
      },
    },

    description: {
      get() {
        return this.current.description;
      },

      set(description) {
        this.setValue({ description });
      },
    },

    icon: {
      get() {
        return this.current.icon;
      },

      set(icon) {
        this.setValue({ icon });
      },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'advantageCompany/setValue',
    }),

    resetForm() {
      this.$store.commit('advantageCompany/clearCurrent');
      this.$router.push({ name: 'advantage-companies' });
    },

    copy() {
      this.$store.commit('advantageCompany/setCurrent', this.$route.params.id);
      this.setValue({ id: null });
      this.$router.push({ name: 'advantages-company-edit', params: { id: 'new' } });
    },

    async remove() {
      await this.$store.dispatch('advantageCompany/remove', this.$route.params.id);
      this.$router.push({ name: 'advantage-companies' });
    },

    async save(isRedirect = false) {
      const id = await this.$store.dispatch('advantageCompany/save');
      if (!isRedirect) {
        this.$router.push({
          name: 'advantages-company-edit',
          params: {
            id,
          },
        }).catch(err => {});
      } else {
        this.resetForm();
      }
    },
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTabs,
    SvMenu,
    SvRadio,
    SvUpload,
  },
};
</script>

<style lang="scss" scoped>
.advantages-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.advantages-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;
}

.advantages-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.advantages-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.advantages-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.advantages-edit__form {
    padding: 50px 0;
}

.advantages-edit__form-radio {
    margin-right: 21px;
}

.advantages-edit__form-elements--medium {
    width: 495px;
}

.advantages-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.advantages-edit__search {
    width: 47%;
    min-width: 280px;
}
</style>
